import React from "react";

import { SideMenuContent } from "./SideMenuContent";

export const DesktopSideMenu = React.memo(function DesktopSideMenu() {
    return (
        <div className={"side_menu"}>
            <ul>
                <SideMenuContent />
            </ul>
        </div>
    );
});
